import React, { useEffect, useState } from "react";
import client from "../lib/api";
import Layout, { PageHero } from "../components/site/Layout";
import { FocusCard } from "../components/site/common";

export default function Activities() {
  const [activities, setActivities] = useState([]);
  useEffect(() => { client.get("/public/activities").then(({ data }) => setActivities(data)).catch(() => {}); }, []);

  return (
    <Layout>
      <PageHero
        eyebrow="Our Activities · Areas of Focus"
        title="Serving faith, people and community."
        intro="These nine areas represent the Trust's areas of focus. Religious and temple-related service is our primary sector."
      />
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-24">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {activities.map((a, i) => (
            <FocusCard key={a.id} item={a} index={i} highlight={i === 0} />
          ))}
        </div>
        <p className="mt-12 max-w-3xl text-sm leading-relaxed text-ink-muted">
          These areas represent the Trust's focus and future initiatives. They do not imply completed activities unless officially confirmed and published by the Trust.
        </p>
      </section>
    </Layout>
  );
}
